// Sales Report Dashboard — the screen's strings in the portal's four languages (2026-10-21).
// What is NOT here, on purpose: the filter VALUES (entities, channels, customers, months, weeks, currencies) and
// the section names and row names the server sends — they are data, POSTed back as filters; the month
// abbreviations (Jan…Dec), which the visual history also matches by name; and the column headings of the PDF
// export, which the screen builds from the English set: the server draws the PDF in DejaVu Sans, which has no
// Hangul or Han glyphs, so a Korean or Chinese heading would print as empty boxes.
const en = {
  title: 'Business Performance',
  // filter bar
  fReport: 'Report',
  fYear: 'Year',
  fMonth: 'Month',
  fQuarter: 'Quarter',
  fWeek: 'Week',
  fCurrency: 'Currency',
  fEntity: 'Entity',
  fChannel: 'Channel',
  fSubchannel: 'Subchannel',
  fCustomerName: 'Customer Name',
  fLine: 'Line',
  fRegion: 'Region',
  fSubregion: 'Subregion',
  fCountry: 'Country',
  all: 'All',
  allLabel: 'All {{label}}',
  reportWeekly: 'Weekly Page',
  reportWeekly2: 'Weekly Report 2',
  reportMonthly: 'Monthly Page',
  reportWeeklyFlash: 'Weekly Flash Report',
  loading: 'Loading...',
  refresh: 'Refresh',
  exporting: 'Exporting...',
  exportPdf: 'Export PDF',
  exportExcel: 'Export Excel',
  clearFilter: 'Clear Filter',
  clearTitle: 'Reset Entity, Channel, Subchannel, Customer Name, SKU, Region, Subregion, Country to All',
  excludeDistributor: 'Exclude Distributor',
  includeOversea: 'Include Oversea',
  includeInternal: 'Include Internal',
  autoRun: 'Auto run',
  showVisuals: 'Show visuals',
  loadingFilters: 'Loading filters...',
  fromCache: 'Loaded from RAM cache',
  updatingSnapshot: 'Updating monthly snapshot...',
  snapshotTimeout: 'Weekly data ready. Monthly snapshot skipped after 15 seconds.',
  snapshotFailed: 'Monthly snapshot request failed',
  emptyPrompt: 'Choose filters and click Refresh to load the report.',
  monthN: 'Month {{month}}',
  errLoadFilters: 'Cannot load filters',
  errExport: 'Cannot export {{what}}',
  errParse: 'Cannot parse {{name}} response',
  errLoad: 'Cannot load {{name}} report',
  statusPass: 'Pass',
  statusFail: 'Fail',
  topN: 'Top {{n}}',
  // report table columns (screen only — the PDF keeps the English set)
  col: {
    qty: 'Qty',
    qtyLy: 'Qty LY',
    growthLy: 'Growth LY',
    mix: '% Mix',
    amount: 'Amount ({{currency}})',
    amountLy: 'Amount LY ({{currency}})',
    prevQty: '{{week}} Qty',
    growthVs: '% Growth of {{week}} vs {{prev}}',
    prevAmount: '{{week}} Amount ({{currency}})',
    weeklyTarget: 'Weekly Target\n({{currency}})',
    weeklyAchieved: 'Weekly % Achieved',
    weeklyStatus: 'Weekly Status',
    mtdAmountSnap: 'MTD Amount\n{{date}}\n({{currency}})',
    monthlyTargetSnap: 'Monthly Target\n{{date}}\n({{currency}})',
    mtdAchievedSnap: 'MTD Monthly % Achieved\n{{date}}',
    mtdStatusSnap: 'MTD Monthly Status\n{{date}}',
    qtyLyMtd: 'Qty LY MTD',
    amountNl: 'Amount\n({{currency}})',
    amountLyMtd: 'Amount LY MTD\n({{currency}})',
    ytdQty: 'YTD Qty',
    ytdQtyLyMtd: 'YTD Qty LY MTD',
    ytdGrowth: 'YTD Growth',
    ytdMix: 'YTD % Mix',
    ytdAmount: 'YTD Amount\n({{currency}})',
    ytdAmountLyMtd: 'YTD Amount LY\nMTD\n({{currency}})',
    ytdAmountGrowth: 'YTD Amount Growth',
    ytdAmountMix: 'YTD Amount % Mix',
    monthlyTarget: 'Monthly Target\n({{currency}})',
    mtdAchieved: 'MTD % Achieved',
    mtdStatus: 'MTD Status',
    ytdTarget: 'YTD Target\n({{currency}})',
    ytdTargetPct: 'YTD Amount /\nYTD Target %',
    ytdStatus: 'YTD Status',
    yearlyTarget: 'Yearly Target\n({{currency}})',
    yearlyTargetPct: 'YTD / Yearly\nTarget %',
    yearlyStatus: 'Yearly Status',
    yearlyDays: 'Yearly # Day',
    yearlyProjected: 'Yearly Projected\n({{currency}})',
    projectedPct: 'Projected / Yearly\nTarget %',
    yearlyProjectedStatus: 'Yearly Projected\nStatus',
  },
  // Weekly Flash Report
  flashEyebrow: 'Weekly meeting view',
  flashPeriod: '{{week}} / Month {{month}} / YTD / {{year}} / {{currency}}',
  flashWeekly: 'WEEKLY',
  kpiRevenue: '{{period}} Revenue',
  kpiGrowth: '{{period}} Growth',
  flashNote: 'MTD and YTD use the selected month snapshot. Mix HEMA is calculated against HEMA total revenue in the same period.',
  flashColRevenue: 'REVENUE',
  flashColGrowth: 'GROWTH',
  flashColMixHema: 'MIX HEMA',
  flashColQty: 'QTY',
  flashNoRow: 'No matching row in current monthly data.',
  flashHemaRevenue: 'HEMA Revenue',
  flashWholesale: 'Wholesale',
  flashWholesaleEast: 'Wholesale East',
  flashWholesaleWest: 'Wholesale West',
  // Weekly Report 2
  w2AccumAttain: 'Accumm. Attain (%)',
  target: 'Target',
  actual: 'Actual',
  rows: '{{n}} rows',
  w2WeeklyReport: 'Weekly Report',
  expandName: 'Expand {{name}}',
  collapseName: 'Collapse {{name}}',
  yearTotal: '{{year}} Total',
  targetAttn: 'Target Attn.',
  vsPy: 'vs. PY',
  vsPq: 'vs. PQ',
  quarterTarget: '{{year}}{{quarter}} Target',
  totalTarget: 'Total Target',
  global: 'Global',
  w2Title: '{{entity}} Weekly Report 2',
  w2SubFull: '{{year}} / full year weekly view / quarter and year totals',
  w2SubQuarter: '{{year}} / {{quarter}} weekly view / quarter and year totals',
  yearActual: 'Year Actual',
  yearTarget: 'Year Target',
  w2WeeklyGlobal: 'Weekly Global',
  byCategory: 'By Category',
  byProductLine: 'By Product Line',
  // visual analytics
  loadingShort: 'Loading',
  loadingChart: 'Loading chart...',
  loadingTrend: 'Loading trend...',
  loadingMap: 'Loading map...',
  loadingMapShort: 'Loading map',
  abNoTarget: 'Target not available for the selected filters',
  abNoComparison: 'Target comparison is not available for this filter',
  abMonthActual: 'Month actual',
  abProjected: 'Projected',
  abYtdActual: 'YTD actual',
  abWeekActual: 'Week actual',
  abMtdActual: 'MTD actual',
  abMtdProjected: 'MTD projected',
  abLine: '{{actual}} actual / {{target}} target',
  abLineProj: '{{actual}} actual · proj {{projected}} / {{target}} target',
  abAchieve: 'Achieve {{pct}}%',
  abDiff: 'Diff {{amount}}',
  visAria: 'Report-specific visual analytics',
  visTitle: 'Visual Analytics',
  visMonthly: 'Monthly visuals for {{month}} {{year}}',
  visWeekly: 'Weekly visuals for {{week}} with W-1 to W-4 context',
  visOnTrack: '{{pass}}/{{n}} entities on track',
  selectedMonth: 'selected month',
  selectedWeek: 'selected week',
  updatingTrend: 'Updating trend...',
  monthlyView: 'Monthly View',
  weeklyView: 'Weekly View',
  kpiMonthActual: 'Month Actual',
  kpiWeekActual: 'Week Actual',
  budgetVariance: 'Budget Variance',
  actualTargetRatio: 'Actual / Target',
  actualMix: 'Actual Mix',
  achieveYtd: 'Achieve% YTD',
  achieveMtd: 'Achieve% MTD',
  seriesAch: 'Ach%',
  seriesMix: 'Mix%',
  seriesAmount: 'Amount',
  currentLabel: 'Current',
  noTrend: 'No trend data',
  noEntityData: 'No entity data',
  noChannelData: 'No channel data',
  noData: 'No data',
  mapNoCountry: 'Country breakdown not available at this filter level.',
  mapHint: 'Apply a broader region filter to enable country view.',
  continentNorthAmerica: 'NORTH AMERICA',
  continentSouthAmerica: 'SOUTH AMERICA',
  continentEurope: 'EUROPE',
  continentAfrica: 'AFRICA',
  continentAsia: 'ASIA',
  continentOceania: 'OCEANIA',
  withAch: 'with achievement %',
  withAchPeriod: 'with achievement % · {{period}}',
  cardTrendMonthly: 'Actual vs Target trend',
  cardTrendWeekly: 'Weekly trend — actual & target',
  cardActualVsTarget: 'Actual vs Target',
  varianceDetail: 'variance detail',
  cardEntity: 'Entity breakdown',
  cardChannel: 'Channel breakdown',
  breakdownEyebrow: 'actual · budget · ach% · mix%',
  topCustomers: 'Top {{n}} customers',
  topSkus: 'Top {{n}} SKUs',
  topLines: 'Top {{n}} Lines',
  cardCountryMap: 'Country revenue map',
  cardLineMix: 'Product line mix',
  cardCategoryMix: 'Product category mix',
  cardTypeMix: 'Product type mix',
  pctOfRevenue: '% of total revenue',
};

const ko = {
  title: '비즈니스 성과',
  fReport: '리포트',
  fYear: '연도',
  fMonth: '월',
  fQuarter: '분기',
  fWeek: '주',
  fCurrency: '통화',
  fEntity: '법인',
  fChannel: '채널',
  fSubchannel: '서브채널',
  fCustomerName: '고객명',
  fLine: '라인',
  fRegion: '지역',
  fSubregion: '세부 지역',
  fCountry: '국가',
  all: '전체',
  allLabel: '전체 {{label}}',
  reportWeekly: '주간 페이지',
  reportWeekly2: '주간 리포트 2',
  reportMonthly: '월간 페이지',
  reportWeeklyFlash: '주간 플래시 리포트',
  loading: '불러오는 중...',
  refresh: '새로고침',
  exporting: '내보내는 중...',
  exportPdf: 'PDF 내보내기',
  exportExcel: 'Excel 내보내기',
  clearFilter: '필터 초기화',
  clearTitle: '법인, 채널, 서브채널, 고객명, SKU, 지역, 세부 지역, 국가를 전체로 되돌립니다',
  excludeDistributor: '디스트리뷰터 제외',
  includeOversea: '해외 포함',
  includeInternal: '내부 거래 포함',
  autoRun: '자동 실행',
  showVisuals: '차트 보기',
  loadingFilters: '필터 불러오는 중...',
  fromCache: 'RAM 캐시에서 불러옴',
  updatingSnapshot: '월간 스냅샷 갱신 중...',
  snapshotTimeout: '주간 데이터 준비 완료. 월간 스냅샷은 15초가 지나 건너뛰었습니다.',
  snapshotFailed: '월간 스냅샷 요청 실패',
  emptyPrompt: '필터를 선택하고 새로고침을 눌러 리포트를 불러오세요.',
  monthN: '{{month}}월',
  errLoadFilters: '필터를 불러올 수 없습니다',
  errExport: '{{what}}(으)로 내보낼 수 없습니다',
  errParse: '{{name}} 응답을 읽을 수 없습니다',
  errLoad: '{{name}} 리포트를 불러올 수 없습니다',
  statusPass: '달성',
  statusFail: '미달',
  topN: '상위 {{n}}',
  col: {
    qty: '수량',
    qtyLy: '수량 LY',
    growthLy: '성장률 LY',
    mix: '비중 %',
    amount: '금액 ({{currency}})',
    amountLy: '금액 LY ({{currency}})',
    prevQty: '{{week}} 수량',
    growthVs: '{{week}} vs {{prev}} 성장률 %',
    prevAmount: '{{week}} 금액 ({{currency}})',
    weeklyTarget: '주간 목표\n({{currency}})',
    weeklyAchieved: '주간 달성률 %',
    weeklyStatus: '주간 상태',
    mtdAmountSnap: 'MTD 금액\n{{date}}\n({{currency}})',
    monthlyTargetSnap: '월간 목표\n{{date}}\n({{currency}})',
    mtdAchievedSnap: 'MTD 월간 달성률 %\n{{date}}',
    mtdStatusSnap: 'MTD 월간 상태\n{{date}}',
    qtyLyMtd: '수량 LY MTD',
    amountNl: '금액\n({{currency}})',
    amountLyMtd: '금액 LY MTD\n({{currency}})',
    ytdQty: 'YTD 수량',
    ytdQtyLyMtd: 'YTD 수량 LY MTD',
    ytdGrowth: 'YTD 성장률',
    ytdMix: 'YTD 비중 %',
    ytdAmount: 'YTD 금액\n({{currency}})',
    ytdAmountLyMtd: 'YTD 금액 LY\nMTD\n({{currency}})',
    ytdAmountGrowth: 'YTD 금액 성장률',
    ytdAmountMix: 'YTD 금액 비중 %',
    monthlyTarget: '월간 목표\n({{currency}})',
    mtdAchieved: 'MTD 달성률 %',
    mtdStatus: 'MTD 상태',
    ytdTarget: 'YTD 목표\n({{currency}})',
    ytdTargetPct: 'YTD 금액 /\nYTD 목표 %',
    ytdStatus: 'YTD 상태',
    yearlyTarget: '연간 목표\n({{currency}})',
    yearlyTargetPct: 'YTD /\n연간 목표 %',
    yearlyStatus: '연간 상태',
    yearlyDays: '연간 일수',
    yearlyProjected: '연간 예상\n({{currency}})',
    projectedPct: '예상 /\n연간 목표 %',
    yearlyProjectedStatus: '연간 예상\n상태',
  },
  flashEyebrow: '주간 회의용 화면',
  flashPeriod: '{{week}} / {{month}}월 / YTD / {{year}} / {{currency}}',
  flashWeekly: '주간',
  kpiRevenue: '{{period}} 매출',
  kpiGrowth: '{{period}} 성장률',
  flashNote: 'MTD와 YTD는 선택한 월의 스냅샷 기준입니다. HEMA 비중은 같은 기간 HEMA 전체 매출 대비로 계산합니다.',
  flashColRevenue: '매출',
  flashColGrowth: '성장률',
  flashColMixHema: 'HEMA 비중',
  flashColQty: '수량',
  flashNoRow: '현재 월간 데이터에 해당하는 행이 없습니다.',
  flashHemaRevenue: 'HEMA 매출',
  flashWholesale: '도매',
  flashWholesaleEast: '도매 동부',
  flashWholesaleWest: '도매 서부',
  w2AccumAttain: '누적 달성률 (%)',
  target: '목표',
  actual: '실적',
  rows: '{{n}}행',
  w2WeeklyReport: '주간 리포트',
  expandName: '{{name}} 펼치기',
  collapseName: '{{name}} 접기',
  yearTotal: '{{year}} 합계',
  targetAttn: '목표 달성률',
  vsPy: '전년 대비',
  vsPq: '전분기 대비',
  quarterTarget: '{{year}}{{quarter}} 목표',
  totalTarget: '전체 목표',
  global: '글로벌',
  w2Title: '{{entity}} 주간 리포트 2',
  w2SubFull: '{{year}} / 연간 주별 보기 / 분기·연간 합계',
  w2SubQuarter: '{{year}} / {{quarter}} 주별 보기 / 분기·연간 합계',
  yearActual: '연간 실적',
  yearTarget: '연간 목표',
  w2WeeklyGlobal: '주간 글로벌',
  byCategory: '카테고리별',
  byProductLine: '제품 라인별',
  loadingShort: '불러오는 중',
  loadingChart: '차트 불러오는 중...',
  loadingTrend: '추이 불러오는 중...',
  loadingMap: '지도 불러오는 중...',
  loadingMapShort: '지도 불러오는 중',
  abNoTarget: '선택한 필터에는 목표가 없습니다',
  abNoComparison: '이 필터에서는 목표 비교를 할 수 없습니다',
  abMonthActual: '월 실적',
  abProjected: '예상',
  abYtdActual: 'YTD 실적',
  abWeekActual: '주 실적',
  abMtdActual: 'MTD 실적',
  abMtdProjected: 'MTD 예상',
  abLine: '실적 {{actual}} / 목표 {{target}}',
  abLineProj: '실적 {{actual}} · 예상 {{projected}} / 목표 {{target}}',
  abAchieve: '달성 {{pct}}%',
  abDiff: '차이 {{amount}}',
  visAria: '리포트별 시각 분석',
  visTitle: '시각 분석',
  visMonthly: '{{year}} {{month}} 월간 차트',
  visWeekly: '{{week}} 주간 차트 (W-1 ~ W-4 포함)',
  visOnTrack: '{{pass}}/{{n}}개 법인 목표 달성',
  selectedMonth: '선택한 월',
  selectedWeek: '선택한 주',
  updatingTrend: '추이 갱신 중...',
  monthlyView: '월간 보기',
  weeklyView: '주간 보기',
  kpiMonthActual: '월 실적',
  kpiWeekActual: '주 실적',
  budgetVariance: '목표 대비 차이',
  actualTargetRatio: '실적 / 목표',
  actualMix: '실적 비중',
  achieveYtd: 'YTD 달성률%',
  achieveMtd: 'MTD 달성률%',
  seriesAch: '달성률%',
  seriesMix: '비중%',
  seriesAmount: '금액',
  currentLabel: '현재',
  noTrend: '추이 데이터 없음',
  noEntityData: '법인 데이터 없음',
  noChannelData: '채널 데이터 없음',
  noData: '데이터 없음',
  mapNoCountry: '이 필터 수준에서는 국가별 분석을 볼 수 없습니다.',
  mapHint: '국가별 보기를 쓰려면 더 넓은 지역 필터를 적용하세요.',
  continentNorthAmerica: '북미',
  continentSouthAmerica: '남미',
  continentEurope: '유럽',
  continentAfrica: '아프리카',
  continentAsia: '아시아',
  continentOceania: '오세아니아',
  withAch: '달성률 % 포함',
  withAchPeriod: '달성률 % 포함 · {{period}}',
  cardTrendMonthly: '실적 vs 목표 추이',
  cardTrendWeekly: '주간 추이 — 실적 및 목표',
  cardActualVsTarget: '실적 vs 목표',
  varianceDetail: '차이 상세',
  cardEntity: '법인별 분석',
  cardChannel: '채널별 분석',
  breakdownEyebrow: '실적 · 목표 · 달성률% · 비중%',
  topCustomers: '상위 {{n}}개 고객',
  topSkus: '상위 {{n}}개 SKU',
  topLines: '상위 {{n}}개 라인',
  cardCountryMap: '국가별 매출 지도',
  cardLineMix: '제품 라인 비중',
  cardCategoryMix: '제품 카테고리 비중',
  cardTypeMix: '제품 유형 비중',
  pctOfRevenue: '전체 매출 대비 %',
};

const vi = {
  title: 'Hiệu quả kinh doanh',
  fReport: 'Báo cáo',
  fYear: 'Năm',
  fMonth: 'Tháng',
  fQuarter: 'Quý',
  fWeek: 'Tuần',
  fCurrency: 'Tiền tệ',
  fEntity: 'Pháp nhân',
  fChannel: 'Kênh',
  fSubchannel: 'Kênh phụ',
  fCustomerName: 'Tên khách hàng',
  fLine: 'Dòng sản phẩm',
  fRegion: 'Khu vực',
  fSubregion: 'Tiểu khu vực',
  fCountry: 'Quốc gia',
  all: 'Tất cả',
  allLabel: 'Tất cả {{label}}',
  reportWeekly: 'Trang tuần',
  reportWeekly2: 'Báo cáo tuần 2',
  reportMonthly: 'Trang tháng',
  reportWeeklyFlash: 'Báo cáo nhanh tuần',
  loading: 'Đang tải...',
  refresh: 'Làm mới',
  exporting: 'Đang xuất...',
  exportPdf: 'Xuất PDF',
  exportExcel: 'Xuất Excel',
  clearFilter: 'Xóa bộ lọc',
  clearTitle: 'Đặt lại Pháp nhân, Kênh, Kênh phụ, Tên khách hàng, SKU, Khu vực, Tiểu khu vực, Quốc gia về Tất cả',
  excludeDistributor: 'Loại nhà phân phối',
  includeOversea: 'Gồm nước ngoài',
  includeInternal: 'Gồm nội bộ',
  autoRun: 'Tự chạy',
  showVisuals: 'Hiện biểu đồ',
  loadingFilters: 'Đang tải bộ lọc...',
  fromCache: 'Tải từ bộ nhớ đệm RAM',
  updatingSnapshot: 'Đang cập nhật snapshot tháng...',
  snapshotTimeout: 'Đã có dữ liệu tuần. Bỏ qua snapshot tháng sau 15 giây.',
  snapshotFailed: 'Yêu cầu snapshot tháng thất bại',
  emptyPrompt: 'Chọn bộ lọc rồi bấm Làm mới để tải báo cáo.',
  monthN: 'Tháng {{month}}',
  errLoadFilters: 'Không tải được bộ lọc',
  errExport: 'Không xuất được {{what}}',
  errParse: 'Không đọc được phản hồi {{name}}',
  errLoad: 'Không tải được báo cáo {{name}}',
  statusPass: 'Đạt',
  statusFail: 'Không đạt',
  topN: 'Top {{n}}',
  col: {
    qty: 'SL',
    qtyLy: 'SL LY',
    growthLy: 'Tăng trưởng LY',
    mix: '% Tỷ trọng',
    amount: 'Doanh số ({{currency}})',
    amountLy: 'Doanh số LY ({{currency}})',
    prevQty: 'SL {{week}}',
    growthVs: '% tăng trưởng {{week}} so với {{prev}}',
    prevAmount: 'Doanh số {{week}} ({{currency}})',
    weeklyTarget: 'Mục tiêu tuần\n({{currency}})',
    weeklyAchieved: '% đạt tuần',
    weeklyStatus: 'Trạng thái tuần',
    mtdAmountSnap: 'Doanh số MTD\n{{date}}\n({{currency}})',
    monthlyTargetSnap: 'Mục tiêu tháng\n{{date}}\n({{currency}})',
    mtdAchievedSnap: '% đạt tháng MTD\n{{date}}',
    mtdStatusSnap: 'Trạng thái tháng MTD\n{{date}}',
    qtyLyMtd: 'SL LY MTD',
    amountNl: 'Doanh số\n({{currency}})',
    amountLyMtd: 'Doanh số LY MTD\n({{currency}})',
    ytdQty: 'SL YTD',
    ytdQtyLyMtd: 'SL YTD LY MTD',
    ytdGrowth: 'Tăng trưởng YTD',
    ytdMix: '% tỷ trọng YTD',
    ytdAmount: 'Doanh số YTD\n({{currency}})',
    ytdAmountLyMtd: 'Doanh số YTD LY\nMTD\n({{currency}})',
    ytdAmountGrowth: 'Tăng trưởng doanh số YTD',
    ytdAmountMix: '% tỷ trọng doanh số YTD',
    monthlyTarget: 'Mục tiêu tháng\n({{currency}})',
    mtdAchieved: '% đạt MTD',
    mtdStatus: 'Trạng thái MTD',
    ytdTarget: 'Mục tiêu YTD\n({{currency}})',
    ytdTargetPct: 'Doanh số YTD /\nMục tiêu YTD %',
    ytdStatus: 'Trạng thái YTD',
    yearlyTarget: 'Mục tiêu năm\n({{currency}})',
    yearlyTargetPct: 'YTD /\nMục tiêu năm %',
    yearlyStatus: 'Trạng thái năm',
    yearlyDays: 'Số ngày (năm)',
    yearlyProjected: 'Dự phóng năm\n({{currency}})',
    projectedPct: 'Dự phóng /\nMục tiêu năm %',
    yearlyProjectedStatus: 'Trạng thái\ndự phóng năm',
  },
  flashEyebrow: 'Màn hình họp tuần',
  flashPeriod: '{{week}} / Tháng {{month}} / YTD / {{year}} / {{currency}}',
  flashWeekly: 'TUẦN',
  kpiRevenue: 'Doanh thu {{period}}',
  kpiGrowth: 'Tăng trưởng {{period}}',
  flashNote: 'MTD và YTD lấy theo snapshot của tháng đã chọn. Tỷ trọng HEMA tính trên tổng doanh thu HEMA cùng kỳ.',
  flashColRevenue: 'DOANH THU',
  flashColGrowth: 'TĂNG TRƯỞNG',
  flashColMixHema: 'TỶ TRỌNG HEMA',
  flashColQty: 'SL',
  flashNoRow: 'Không có dòng phù hợp trong dữ liệu tháng hiện tại.',
  flashHemaRevenue: 'Doanh thu HEMA',
  flashWholesale: 'Bán sỉ',
  flashWholesaleEast: 'Bán sỉ miền Đông',
  flashWholesaleWest: 'Bán sỉ miền Tây',
  w2AccumAttain: 'Tỷ lệ đạt lũy kế (%)',
  target: 'Mục tiêu',
  actual: 'Thực tế',
  rows: '{{n}} dòng',
  w2WeeklyReport: 'Báo cáo tuần',
  expandName: 'Mở {{name}}',
  collapseName: 'Thu gọn {{name}}',
  yearTotal: 'Tổng {{year}}',
  targetAttn: '% đạt mục tiêu',
  vsPy: 'so với năm trước',
  vsPq: 'so với quý trước',
  quarterTarget: 'Mục tiêu {{year}}{{quarter}}',
  totalTarget: 'Tổng mục tiêu',
  global: 'Toàn cầu',
  w2Title: '{{entity}} — Báo cáo tuần 2',
  w2SubFull: '{{year}} / theo tuần cả năm / tổng quý và năm',
  w2SubQuarter: '{{year}} / theo tuần {{quarter}} / tổng quý và năm',
  yearActual: 'Thực tế năm',
  yearTarget: 'Mục tiêu năm',
  w2WeeklyGlobal: 'Toàn cầu theo tuần',
  byCategory: 'Theo nhóm hàng',
  byProductLine: 'Theo dòng sản phẩm',
  loadingShort: 'Đang tải',
  loadingChart: 'Đang tải biểu đồ...',
  loadingTrend: 'Đang tải xu hướng...',
  loadingMap: 'Đang tải bản đồ...',
  loadingMapShort: 'Đang tải bản đồ',
  abNoTarget: 'Không có mục tiêu cho bộ lọc đã chọn',
  abNoComparison: 'Không so sánh được với mục tiêu ở bộ lọc này',
  abMonthActual: 'Thực tế tháng',
  abProjected: 'Dự phóng',
  abYtdActual: 'Thực tế YTD',
  abWeekActual: 'Thực tế tuần',
  abMtdActual: 'Thực tế MTD',
  abMtdProjected: 'Dự phóng MTD',
  abLine: 'Thực tế {{actual}} / mục tiêu {{target}}',
  abLineProj: 'Thực tế {{actual}} · dự phóng {{projected}} / mục tiêu {{target}}',
  abAchieve: 'Đạt {{pct}}%',
  abDiff: 'Chênh lệch {{amount}}',
  visAria: 'Phân tích trực quan theo báo cáo',
  visTitle: 'Phân tích trực quan',
  visMonthly: 'Biểu đồ tháng {{month}} {{year}}',
  visWeekly: 'Biểu đồ tuần {{week}}, kèm W-1 đến W-4',
  visOnTrack: '{{pass}}/{{n}} pháp nhân đạt mục tiêu',
  selectedMonth: 'tháng đã chọn',
  selectedWeek: 'tuần đã chọn',
  updatingTrend: 'Đang cập nhật xu hướng...',
  monthlyView: 'Xem theo tháng',
  weeklyView: 'Xem theo tuần',
  kpiMonthActual: 'Thực tế tháng',
  kpiWeekActual: 'Thực tế tuần',
  budgetVariance: 'Chênh lệch so với mục tiêu',
  actualTargetRatio: 'Thực tế / Mục tiêu',
  actualMix: 'Tỷ trọng thực tế',
  achieveYtd: '% đạt YTD',
  achieveMtd: '% đạt MTD',
  seriesAch: '% đạt',
  seriesMix: '% tỷ trọng',
  seriesAmount: 'Doanh số',
  currentLabel: 'Hiện tại',
  noTrend: 'Không có dữ liệu xu hướng',
  noEntityData: 'Không có dữ liệu pháp nhân',
  noChannelData: 'Không có dữ liệu kênh',
  noData: 'Không có dữ liệu',
  mapNoCountry: 'Không xem được phân bổ theo quốc gia ở mức lọc này.',
  mapHint: 'Dùng bộ lọc khu vực rộng hơn để xem theo quốc gia.',
  continentNorthAmerica: 'BẮC MỸ',
  continentSouthAmerica: 'NAM MỸ',
  continentEurope: 'CHÂU ÂU',
  continentAfrica: 'CHÂU PHI',
  continentAsia: 'CHÂU Á',
  continentOceania: 'CHÂU ĐẠI DƯƠNG',
  withAch: 'kèm % đạt',
  withAchPeriod: 'kèm % đạt · {{period}}',
  cardTrendMonthly: 'Xu hướng thực tế so với mục tiêu',
  cardTrendWeekly: 'Xu hướng tuần — thực tế và mục tiêu',
  cardActualVsTarget: 'Thực tế so với mục tiêu',
  varianceDetail: 'chi tiết chênh lệch',
  cardEntity: 'Phân tích theo pháp nhân',
  cardChannel: 'Phân tích theo kênh',
  breakdownEyebrow: 'thực tế · mục tiêu · % đạt · % tỷ trọng',
  topCustomers: 'Top {{n}} khách hàng',
  topSkus: 'Top {{n}} SKU',
  topLines: 'Top {{n}} dòng sản phẩm',
  cardCountryMap: 'Bản đồ doanh thu theo quốc gia',
  cardLineMix: 'Tỷ trọng dòng sản phẩm',
  cardCategoryMix: 'Tỷ trọng nhóm hàng',
  cardTypeMix: 'Tỷ trọng loại sản phẩm',
  pctOfRevenue: '% trên tổng doanh thu',
};

const zh = {
  title: '经营绩效',
  fReport: '报告',
  fYear: '年',
  fMonth: '月',
  fQuarter: '季度',
  fWeek: '周',
  fCurrency: '币种',
  fEntity: '法人实体',
  fChannel: '渠道',
  fSubchannel: '子渠道',
  fCustomerName: '客户名称',
  fLine: '产品线',
  fRegion: '区域',
  fSubregion: '子区域',
  fCountry: '国家',
  all: '全部',
  allLabel: '全部{{label}}',
  reportWeekly: '周报页',
  reportWeekly2: '周报 2',
  reportMonthly: '月报页',
  reportWeeklyFlash: '周快报',
  loading: '加载中...',
  refresh: '刷新',
  exporting: '导出中...',
  exportPdf: '导出 PDF',
  exportExcel: '导出 Excel',
  clearFilter: '清除筛选',
  clearTitle: '将法人实体、渠道、子渠道、客户名称、SKU、区域、子区域、国家重置为全部',
  excludeDistributor: '排除经销商',
  includeOversea: '包含海外',
  includeInternal: '包含内部',
  autoRun: '自动运行',
  showVisuals: '显示图表',
  loadingFilters: '正在加载筛选项...',
  fromCache: '从 RAM 缓存加载',
  updatingSnapshot: '正在更新月度快照...',
  snapshotTimeout: '周数据已就绪。月度快照超过 15 秒，已跳过。',
  snapshotFailed: '月度快照请求失败',
  emptyPrompt: '请选择筛选条件，然后点击刷新加载报告。',
  monthN: '{{month}}月',
  errLoadFilters: '无法加载筛选项',
  errExport: '无法导出 {{what}}',
  errParse: '无法解析 {{name}} 响应',
  errLoad: '无法加载 {{name}} 报告',
  statusPass: '达成',
  statusFail: '未达成',
  topN: '前 {{n}}',
  col: {
    qty: '数量',
    qtyLy: '数量 LY',
    growthLy: '增长 LY',
    mix: '占比 %',
    amount: '金额 ({{currency}})',
    amountLy: '金额 LY ({{currency}})',
    prevQty: '{{week}} 数量',
    growthVs: '{{week}} 较 {{prev}} 增长 %',
    prevAmount: '{{week}} 金额 ({{currency}})',
    weeklyTarget: '周目标\n({{currency}})',
    weeklyAchieved: '周达成率 %',
    weeklyStatus: '周状态',
    mtdAmountSnap: 'MTD 金额\n{{date}}\n({{currency}})',
    monthlyTargetSnap: '月目标\n{{date}}\n({{currency}})',
    mtdAchievedSnap: 'MTD 月达成率 %\n{{date}}',
    mtdStatusSnap: 'MTD 月状态\n{{date}}',
    qtyLyMtd: '数量 LY MTD',
    amountNl: '金额\n({{currency}})',
    amountLyMtd: '金额 LY MTD\n({{currency}})',
    ytdQty: 'YTD 数量',
    ytdQtyLyMtd: 'YTD 数量 LY MTD',
    ytdGrowth: 'YTD 增长',
    ytdMix: 'YTD 占比 %',
    ytdAmount: 'YTD 金额\n({{currency}})',
    ytdAmountLyMtd: 'YTD 金额 LY\nMTD\n({{currency}})',
    ytdAmountGrowth: 'YTD 金额增长',
    ytdAmountMix: 'YTD 金额占比 %',
    monthlyTarget: '月目标\n({{currency}})',
    mtdAchieved: 'MTD 达成率 %',
    mtdStatus: 'MTD 状态',
    ytdTarget: 'YTD 目标\n({{currency}})',
    ytdTargetPct: 'YTD 金额 /\nYTD 目标 %',
    ytdStatus: 'YTD 状态',
    yearlyTarget: '年度目标\n({{currency}})',
    yearlyTargetPct: 'YTD /\n年度目标 %',
    yearlyStatus: '年度状态',
    yearlyDays: '年度天数',
    yearlyProjected: '年度预测\n({{currency}})',
    projectedPct: '预测 /\n年度目标 %',
    yearlyProjectedStatus: '年度预测\n状态',
  },
  flashEyebrow: '周会视图',
  flashPeriod: '{{week}} / {{month}}月 / YTD / {{year}} / {{currency}}',
  flashWeekly: '周',
  kpiRevenue: '{{period}} 营收',
  kpiGrowth: '{{period}} 增长',
  flashNote: 'MTD 和 YTD 使用所选月份的快照。HEMA 占比按同期 HEMA 总营收计算。',
  flashColRevenue: '营收',
  flashColGrowth: '增长',
  flashColMixHema: 'HEMA 占比',
  flashColQty: '数量',
  flashNoRow: '当前月度数据中没有匹配的行。',
  flashHemaRevenue: 'HEMA 营收',
  flashWholesale: '批发',
  flashWholesaleEast: '批发（东部）',
  flashWholesaleWest: '批发（西部）',
  w2AccumAttain: '累计达成率 (%)',
  target: '目标',
  actual: '实际',
  rows: '{{n}} 行',
  w2WeeklyReport: '周报',
  expandName: '展开 {{name}}',
  collapseName: '收起 {{name}}',
  yearTotal: '{{year}} 合计',
  targetAttn: '目标达成率',
  vsPy: '同比',
  vsPq: '环比上季',
  quarterTarget: '{{year}}{{quarter}} 目标',
  totalTarget: '总目标',
  global: '全球',
  w2Title: '{{entity}} 周报 2',
  w2SubFull: '{{year}} / 全年按周 / 季度和年度合计',
  w2SubQuarter: '{{year}} / {{quarter}} 按周 / 季度和年度合计',
  yearActual: '年度实际',
  yearTarget: '年度目标',
  w2WeeklyGlobal: '全球周数据',
  byCategory: '按品类',
  byProductLine: '按产品线',
  loadingShort: '加载中',
  loadingChart: '正在加载图表...',
  loadingTrend: '正在加载趋势...',
  loadingMap: '正在加载地图...',
  loadingMapShort: '正在加载地图',
  abNoTarget: '所选筛选条件下没有目标',
  abNoComparison: '此筛选条件下无法与目标比较',
  abMonthActual: '本月实际',
  abProjected: '预测',
  abYtdActual: 'YTD 实际',
  abWeekActual: '本周实际',
  abMtdActual: 'MTD 实际',
  abMtdProjected: 'MTD 预测',
  abLine: '实际 {{actual}} / 目标 {{target}}',
  abLineProj: '实际 {{actual}} · 预测 {{projected}} / 目标 {{target}}',
  abAchieve: '达成 {{pct}}%',
  abDiff: '差额 {{amount}}',
  visAria: '报告可视化分析',
  visTitle: '可视化分析',
  visMonthly: '{{year}} {{month}} 月度图表',
  visWeekly: '{{week}} 周度图表（含 W-1 至 W-4）',
  visOnTrack: '{{pass}}/{{n}} 个法人实体达标',
  selectedMonth: '所选月份',
  selectedWeek: '所选周',
  updatingTrend: '正在更新趋势...',
  monthlyView: '月视图',
  weeklyView: '周视图',
  kpiMonthActual: '本月实际',
  kpiWeekActual: '本周实际',
  budgetVariance: '目标差额',
  actualTargetRatio: '实际 / 目标',
  actualMix: '实际占比',
  achieveYtd: 'YTD 达成率%',
  achieveMtd: 'MTD 达成率%',
  seriesAch: '达成率%',
  seriesMix: '占比%',
  seriesAmount: '金额',
  currentLabel: '当前',
  noTrend: '没有趋势数据',
  noEntityData: '没有法人实体数据',
  noChannelData: '没有渠道数据',
  noData: '没有数据',
  mapNoCountry: '在此筛选层级下无法按国家细分。',
  mapHint: '请使用范围更大的区域筛选以查看国家视图。',
  continentNorthAmerica: '北美洲',
  continentSouthAmerica: '南美洲',
  continentEurope: '欧洲',
  continentAfrica: '非洲',
  continentAsia: '亚洲',
  continentOceania: '大洋洲',
  withAch: '含达成率 %',
  withAchPeriod: '含达成率 % · {{period}}',
  cardTrendMonthly: '实际与目标趋势',
  cardTrendWeekly: '周趋势 — 实际与目标',
  cardActualVsTarget: '实际与目标',
  varianceDetail: '差额明细',
  cardEntity: '按法人实体细分',
  cardChannel: '按渠道细分',
  breakdownEyebrow: '实际 · 目标 · 达成率% · 占比%',
  topCustomers: '前 {{n}} 名客户',
  topSkus: '前 {{n}} 个 SKU',
  topLines: '前 {{n}} 条产品线',
  cardCountryMap: '国家营收地图',
  cardLineMix: '产品线占比',
  cardCategoryMix: '产品品类占比',
  cardTypeMix: '产品类型占比',
  pctOfRevenue: '占总营收 %',
};

const dictionary = { ns: 'xSales', en, ko, vi, zh };

export default dictionary;
